import { useQuery } from '@tanstack/react-query'
import { fetchConfigDoor, fetchStoreOpeningState } from '../queries/door.queries'

export const useConfigDoor = (storeId: number) =>
  useQuery({
    queryKey: ['doorConfig', storeId],
    queryFn: () => fetchConfigDoor(storeId),
  })

export const useStoreOpeningState = (storeId: number) =>
  useQuery({
    queryKey: ['storeOpeningState', storeId],
    queryFn: () => fetchStoreOpeningState(storeId),
  })
